import { observer } from 'mobx-react-lite'

import Styles from './CollaborationDialogHead.module.scss'
import { ReactNode } from 'react'

export const CollaborationDialogHead = observer(function CollaborationDialogHead({
  children,
}: {
  children: ReactNode
}) {
  return (
    <div className={Styles.head} onTouchStart={(e) => e.stopPropagation()}>
      {children}
    </div>
  )
})
